import React, { useState, useEffect } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import SupplierDocumentService from "../../Controller/SupplierDocumentController";
import CreateSupplierDocument from "./CreateSupplierDocument";
import HelpSite from "../../../Common/HelpLink";
function SupplierDocumentPage({ SupplierID }) {
    SupplierID = localStorage.getItem('SupplierID');
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    const [SupplierDocuemnttList, setSupplierDocument] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentSupplierDocument, setCurrentSupplierDocument] = useState(null);
    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fetchSupplierDocument = async () => {
        try {
            const data = await SupplierDocumentService.GetAllSupplierDocuments(redirectCallback, SupplierID);
            setSupplierDocument(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (SupplierID > 0) {
            fetchSupplierDocument();
        }
        else {
            setSupplierDocument([]);
        }
    }, [SupplierID]);

    const handleCreateSupplierDocumentClick = () => {
        setCurrentSupplierDocument(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (contact) => {
        setCurrentSupplierDocument(contact);
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await SupplierDocumentService.DeleteSupplierDocument(redirectCallback, ID);
                fetchSupplierDocument(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const handleSuccess = () => {
        fetchSupplierDocument(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const getFileExtension = (fileName) => {
        const index = fileName.lastIndexOf('.');
        return index !== -1 ? fileName.substring(index) : '';
    };
    const handleDownload = async (e, docuemnt) => {
        e.stopPropagation();

        const ext = getFileExtension(docuemnt.FileName);
        const customName = `${docuemnt.Name}${ext}`;

        try {

            const response = await fetch(
                `${BASE_URL}/uploads/${CompanyID}/Supplier/Document/${docuemnt.FileName}`
            );
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = customName;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateSupplierDocumentClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <table className="table m-0 table-hover">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Attached File</th>
                                <th style={{ "textAlign": "right" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {SupplierDocuemnttList.map((docuemnt) => (
                                <tr key={docuemnt.DocID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(docuemnt) : undefined}>
                                    <td>{docuemnt.Name}</td>
                                    <td>{docuemnt.Description}</td>
                                    
                                     <td>
                                    <a
                                        href="#"
                                        onClick={(e) => handleDownload(e, docuemnt)}
                                        style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                    >
                                        {`${docuemnt.Name}${getFileExtension(docuemnt.FileName)}`}
                                    </a>
                                </td>
                                    <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                        <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(docuemnt.DocID)}>
                                            <i className="icofont-ui-delete" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {isModalOpen && (
                <CreateSupplierDocument
                    modalInstance={modalInstance}
                    currentSupplierDocument={currentSupplierDocument}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    SupplierID={SupplierID}
                />
            )}
        </div>
    );
}

export default SupplierDocumentPage;
